// AttachmentDropOverlay.jsx — overlay visual quando user arrasta files
// sobre o composer. Reutilizado em SessionComposer, CodeComposer, ChatHomeComposer.

import { Paperclip } from 'lucide-react';
import { MAX_FILES } from '../../hooks/useFileAttachments.js';

export default function AttachmentDropOverlay({ visible }) {
  if (!visible) return null;
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-2 z-20 flex items-center justify-center rounded-lg border-2 border-dashed border-apolo-accent bg-apolo-surface1/95 backdrop-blur-sm"
    >
      <div className="flex flex-col items-center gap-1 text-apolo-accent">
        <Paperclip size={20} aria-hidden="true" />
        <span className="text-sm font-medium">Solte aqui pra anexar</span>
        <span className="text-[10px] text-apolo-textTertiary">
          até {MAX_FILES} arquivos · 25 MB cada · qualquer tipo
        </span>
      </div>
    </div>
  );
}
